/**
 * 布局「返回」目标解析。
 * 优先用 query.backTo（同站相对路径），再退回 meta.layoutBackTo / fallback。
 * 禁止 // 开头，避免开放重定向。
 */

export function resolveLayoutBackTo(route, fallback) {
  const queryBack =
    route && route.query && route.query.backTo != null
      ? String(route.query.backTo).trim()
      : ''
  if (queryBack.startsWith('/') && !queryBack.startsWith('//')) {
    return queryBack
  }
  if (route && route.meta && route.meta.layoutBackTo) {
    return route.meta.layoutBackTo
  }
  return fallback || null
}

/** 跳转时带上 backTo，便于编辑/查看页返回来源列表。 */
export function buildLocationWithBackTo(path, backTo) {
  const location = { path: String(path || '') }
  if (typeof backTo === 'string' && backTo.startsWith('/') && !backTo.startsWith('//')) {
    location.query = { backTo }
  }
  return location
}
